$(document).ready(function() {
  // Creators slider
  if($('.swiper-container.creators').length > 0 ) {
  $(".swiper-container.creators").each(function(i) {
    const directionChange =  $(this).attr('direction');
    if(directionChange ==  'true')
    {
      var mySwiper = new Swiper($(this)[0], {
        spaceBetween: 0,
        centeredSlides: true,
        speed: 6000,
        autoplay: {
          delay: 1,
          reverseDirection: directionChange
        },
        loop: true,
        slidesPerView:'auto',
        allowTouchMove: false,
        disableOnInteraction: true
      });

    }
    else {
      var mySwiper = new Swiper($(this)[0], {
        spaceBetween: 0,
        centeredSlides: true,
        speed: 6000,
        autoplay: {
          delay: 1
        },
        loop: true,
        slidesPerView:'auto',
        allowTouchMove: false,
        disableOnInteraction: true
      });
    }
    
  });
  }
  if($('.sidebar__panel-swiper').length > 0 ) { 
    $(".sidebar__panel-swiper").each(function(i) {
      const navNext =  $(this).find('.swiper-button-next').attr('id');
      const navPrev =  $(this).find('.swiper-button-prev').attr('id');
    {
      var mySwiper = new Swiper($(this)[0], {
        spaceBetween: 0,
        loop: true,
        slidesPerView:1,
        allowTouchMove: true,
        navigation: {
          nextEl: '#'+navNext,
          prevEl: '#'+navPrev,
        },
        disableOnInteraction: true
      });

    }
  });
  }
  // Creators slider
  $("#preloader").delay(1000).fadeOut("slow");
  
});

if ($(window).width() < 750) {
$('.footer-block__heading').each(function () {
  $(this).on('click', function() {
    $(this).toggleClass('clicked');
   $(this).next('.toggle-on-mobile').toggleClass('open', 1000 );
  });
});
};
